import React from 'react';
import { setCurrentView } from 'core/utils';
import { UserListTemplate } from 'themes/modules/user/pages';
import { UserListViewStore } from 'modules/user/stores';

@setCurrentView(rootStore => new UserListViewStore(rootStore), 'userListViewStore')
class UserList extends React.Component {
	constructor(props) {
		super(props);
		const { userListViewStore } = this.props;
		userListViewStore.setSearchVisible();
		this.permissions = userListViewStore.permissions;
		if (this.permissions.create()) {
			userListViewStore.setButtonComponent({
				buttons: [
					{
						className: 'btn btn--dropdown header__button',
						iconClassName: 'fa fa-plus spc--right--sml',
						onClick: userListViewStore.routes.create,
						text: 'USEREDIT.NEW',
					},
				],
			});
		}
	}
	render() {
		return (
			<UserListTemplate
				{...this.props}
				headerCell={[]}
				actions={this.props.userListViewStore}
				viewStore={this.props.userListViewStore}
			/>
		);
	}
}

export default UserList;
